import { AloDataPoolItem } from '@/models/alo/AloDataPoolItem'

export interface  ISocketState {
  isConnected:boolean,
  wasOffline:boolean,
  connectedDate:string,
  reconnectError:boolean,
  message:string  
  keepAliveTimoutId:number
}

//Initial State
const state:ISocketState = {
  isConnected: false,
  wasOffline: false,
  connectedDate: '',
  reconnectError: false,
  message:'',
  keepAliveTimoutId : 0
}

export default state
